import {inject, Injectable} from '@angular/core';
import {DEVICE} from "../../../../../shared/domain/tokens/device.token";
import {SERVICE_STATE_SERVICE} from "../../../../../features/service/domain/tokens/service-state.token";
import {IBookingActivationPayload} from '../../domain/interfaces/booking-activation.payload';

@Injectable({ providedIn: 'root' })
export class BookingActivatePayloadBuilder {
  private readonly deviceService = inject(DEVICE);
  private readonly serviceStateService = inject(SERVICE_STATE_SERVICE);

  build(bookingId: string): IBookingActivationPayload | null {
    const device = this.deviceService.getDeviceInfo();
    const waiter = this.serviceStateService.getCurrentWorker();
    const location = this.serviceStateService.getCurrentLocation();
    const drawer = this.serviceStateService.getCurrentDrawer();

    if (!device || !waiter || !location || !drawer) {
      return null;
    }

    return {
      bookingId,
      deviceId: device?.id ?? '',
      deviceName: device?.name ?? '',
      waiterId: waiter.id,
      locationId: location?.id ?? '',
      cashDrawerId: drawer?.id ?? ''
    };
  }
}
